<template>
	<transition
		type="transition"
		enter-class="grow-enter"
		enter-active-class="grow-enter-active"
		enter-to-class="grow-to"
		leave-to-class="fly-away"
		@after-enter="onAngelCreated"
		@after-leave="deathComplete"
	>
		<div class="cover cat-animation angel" :style="style"></div>
	</transition>
</template>

<script>
import { randomBetween } from '@/mixins/random/';
import { mapState } from 'vuex';

export default {
	name: 'Angel',
	data() {
		return {
			angelCreated: false,
		};
	},
	computed: {
		...mapState({
			gameOver: state => state.gameOver,
		}),
		style() {
			return {
				transform: `translate3d(0, -${this.translateY}vh, 0) scale(${this.scale})`,
				transitionDelay: `${this.transitionDelay}ms`,
				transitionDuration: `${this.transitionDuration}ms`,
				animationDelay: `-${this.animationDelay}ms`,
			};
		},
		translateY() {
			return this.angelCreated ? 100 : 0;
		},
		scale() {
			return this.gameOver ? randomBetween(1, 4) : 1;
		},
		transitionDelay() {
			return this.angelCreated ? randomBetween(500, 1500) : 0;
		},
		transitionDuration() {
			return this.angelCreated ? randomBetween(2000, 3000) : randomBetween(750, 1250);
		},
		animationDelay() {
			return randomBetween(0, 750);
		},
	},
	methods: {
		onAngelCreated() {
			if (!this.gameOver) {
				this.angelCreated = true;
				this.$emit("angelCreated");
			}
		},
		deathComplete() {
			if (!this.gameOver) {
				this.$emit("deathComplete");
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.angel {
		transition: all;
		z-index: 999;
	}

	.fly-away {
		transition-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.335);
		opacity: .2;
	}
</style>



// WEBPACK FOOTER //
// src/components/cat/Angel.vue